import React from "react";

const ListIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <rect x="0" y="1" width="12" height="2" rx="1" fill="currentColor"></rect>
      <rect x="0" y="5" width="12" height="2" rx="1" fill="currentColor"></rect>
      <rect x="0" y="9" width="12" height="2" rx="1" fill="currentColor"></rect>
    </svg>
  );
};

export default ListIcon;
